module.exports = __webpack_public_path__ + "static/media/glygenNotFound.8fe4b8c7.svg";